import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { 
  FaUsers, 
  FaExclamationCircle, 
  FaSyncAlt, 
  FaTachometerAlt 
} from "react-icons/fa";


function PartyManager() {
  const [complaints, setComplaints] = useState([]);
  const [users, setUsers] = useState([]);

  const [loadingComplaints, setLoadingComplaints] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(true);

  // ================= FETCH COMPLAINTS =================
  const fetchComplaints = async () => {
    setLoadingComplaints(true);

    try {
      const res = await fetch(
        "https://tvk-backend-yl1b.onrender.com/api/complaints"
      );

      const data = await res.json();

      if (data.success) {
        setComplaints(data.data);
      } else {
        toast.error("Failed to fetch complaints ❌");
      }
    } catch {
      toast.error("Server error ❌");
    }

    setLoadingComplaints(false);
  };

  // ================= FETCH USERS =================
  const fetchUsers = async () => {
    setLoadingUsers(true);

    try {
      const res = await fetch(
        "https://tvk-backend-yl1b.onrender.com/api/users"
      );

      const data = await res.json();

      if (data.success) {
        setUsers(data.data);
      } else {
        toast.error("Failed to fetch users ❌");
      }
    } catch {
      toast.error("Server error ❌");
    }

    setLoadingUsers(false);
  };

  useEffect(() => {
    fetchComplaints();
    fetchUsers();
  }, []);

  // ================= REFRESH BUTTON =================
  const handleRefresh = () => {
    fetchComplaints();
    fetchUsers();
    toast.success("Data refreshed 🔄");
  };

  // ================= LOGOUT =================
  const handleLogout = () => {
    const confirm = window.confirm("Are you sure you want to logout?");

    if (!confirm) return;

    localStorage.removeItem("isLoggedIn");
    toast.success("Logged out ✅");

    setTimeout(() => {
      window.location.href = "/login";
    }, 500);
  };

  return (
    <div className="manager-container">

      {/* HEADER */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <h2><FaTachometerAlt style={{marginRight:"8px"}}/>Manager Dashboard</h2>


        <div style={{ display: "flex", gap: "10px" }}>

          {/* REFRESH */}
          <button
            onClick={handleRefresh}
            style={{
              padding: "8px 16px",
              background: "#2196f3",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer"
            }}
          >
              <FaSyncAlt style={{marginRight:"6px"}}/>
        Refresh
          </button>

          {/* LOGOUT */}
          <button
            onClick={handleLogout}
            style={{
              padding: "8px 16px",
              background: "red",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer"
            }}
          >
            Logout
          </button>

        </div>
      </div>

      {/* ================= USERS TABLE ================= */}
      <h3><FaUsers style={{marginRight:"8px", color:"#2196f3"}}/>Registered Users</h3>


      {loadingUsers ? (
        <p>Loading users...</p>
      ) : users.length === 0 ? (
        <p>No users found</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Voter ID</th>
              <th>Mobile</th>
              <th>Place</th>
            </tr>
          </thead>

          <tbody>
            {users.map((u, i) => (
              <tr key={i}>
                <td>{u.name}</td>
                <td>{u.voter_id}</td>
                <td>{u.mobile}</td>
                <td>{u.place}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <br />

      {/* ================= COMPLAINTS TABLE ================= */}
      <h3><FaExclamationCircle style={{marginRight:"8px", color:"red"}}/>Complaints</h3>


      {loadingComplaints ? (
        <p>Loading complaints...</p>
      ) : complaints.length === 0 ? (
        <p>No complaints found</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Ward</th>
              <th>Mobile</th>
              <th>Message</th>
            </tr>
          </thead>

          <tbody>
            {complaints.map((c, i) => (
              <tr key={i}>
                <td>{c.name}</td>
                <td>{c.ward}</td>
                <td>{c.mobile}</td>
                <td>{c.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

    </div>
  );
}

export default PartyManager;
